var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2385",
    "data-name": "Grupo 2385",
    transform: "translate(-52 -301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_1278",
    "data-name": "Ret\\xE2ngulo 1278",
    transform: "translate(58 307)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 67,
    height: 67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_72",
    "data-name": "Elipse 72",
    transform: "translate(52 301)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_73",
    "data-name": "Elipse 73",
    transform: "translate(52 368)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_74",
    "data-name": "Elipse 74",
    transform: "translate(119 368)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_75",
    "data-name": "Elipse 75",
    transform: "translate(119 301)",
    fill: "#1e1e1e",
    stroke: "#d3ff9a",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentIcon);
export default __webpack_public_path__ + "static/media/environmentIcon.60d2d551ead8048947e89648e0e263a3.svg";
export { ForwardRef as ReactComponent };